

export default {
    DEBUG: true
}